<template>
  <div id="navWrapper">
    <div id="navContainer">
      <div id="serial">
        <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/"
          >展昭參展商管理系統</a
        >
      </div>
      <ul id="quickLink">
        <!-- <li class="chatcenter" v-if="openRoomCenter && ShowChatCenter">
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/SignalRCenter" target="_blank">通訊管理</a>
        </li> -->
        <li class="indexList" v-if="!ExhiListPage">
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/">展覽列表</a>
        </li>
        <li class="lang">
          <a class="pointer" @click="toEnVersion">English Version</a>
        </li>
        <li class="logout">
          <a href="/apiLogin2/Logout"><span name="Company"></span>登出</a>
        </li>
      </ul>

      <ul id="quickMbLink" v-if="ExhiListPage">
        <li class="lang">
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/en">
            <img src="../assets/images/lang.svg" width="20px" alt="" />
          </a>
        </li>
        <li class="logout mx-2">
          <a
            href="/apiLogin2/Logout"
            onclick=' return confirm("請確認要登出？");'
          >
            <img src="../assets/images/logout.svg" width="20px" alt="" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      ExhiListPage: false,
      getUrl: "",
      UserId: "",
      openRoomCenter: false,
      ShowChatCenter: false,
    };
  },

  computed: {
    ...mapGetters(["ShowRoom"]),
  },

  methods: {
    toEnVersion() {
      const vm = this;

      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en${vm.getUrl}`;
    },

    openChatbox() {
      if (this.ShowRoom) {
        this.$bus.$emit("CloseConnet");
      } else {
        this.$bus.$emit("StartConnet");
      }
    },
  },

  created() {
    const vm = this;
    let nowPage = location.href;
    vm.getUrl = nowPage.split("ExhibitorServiceTW")[1];

    let activePage = nowPage.split("/")[4];
    if (!activePage) {
      vm.ExhiListPage = true;
      let getEmptyPage = nowPage.split("/")[3];

      if (getEmptyPage == "SignalRCenter") {
        vm.ShowChatCenter = false;
      } else {
        vm.ShowChatCenter = true;
      }
    } else {
      vm.ExhiListPage = false;
      let PageName = activePage.split("?")[0];

      if (PageName == "SignalRCenter") {
        vm.ShowChatCenter = false;
      } else {
        vm.ShowChatCenter = true;
      }
    }

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        // console.log(response.data)
        vm.UserId = response.data;

        if (
          vm.UserId == "vince@chanchao.com.tw" ||
          vm.UserId == "jeffrey@chanchao.com.tw" ||
          vm.UserId == "anthony@chanchao.com.tw" ||
          vm.UserId == "macy@chanchao.com.tw"
        ) {
          vm.openRoomCenter = true;
        } else {
          vm.openRoomCenter = false;
        }
      });
  },
};
</script>

<style lang="scss">
#navContainer {
  width: 100%;
  height: 40px;
  background-color: #000;
  position: fixed;
  top: 0;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}

ul#quickLink li.chatroom a {
  background-image: url(../assets/images/chat_icon3.png);
}

ul#quickLink li.chatcenter a {
  background-image: url(../assets/images/chat_icon4.png);
}

ul#quickLink li.lang a {
  background-image: url(../assets/images/lang.svg);
}
ul#quickLink li.member a {
  background-image: url(../assets/images/member.svg);
}

ul#quickLink li.logout a {
  background-image: url(../assets/images/logout.svg);
}

ul#quickLink li.langTw a {
  background-image: url(../assets/images/langTW.svg);
}
ul#quickLink li.indexList a {
  background-image: url(../assets/images/indexList.svg);
}

ul#quickLink {
  position: absolute;
  right: 5%;
  top: 12px;
}

ul#quickMbLink {
  display: none;
}

ul#quickLink li {
  float: left;
  width: auto;
  margin-left: 20px;
  vertical-align: middle;
  list-style-type: none;
}
ul#quickLink li a {
  display: block;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  padding-left: 20px;
  line-height: 16px;
  text-decoration: none;
  color: #fff;
  opacity: 0.7;
}
ul#quickLink li a:hover {
  opacity: 1;
}

ul {
  text-decoration: none;
}

#serial a {
  color: #ffffff;
}

#serial {
  width: 100%;
  position: absolute;
  left: 5%;
  top: 0;
  height: 40px;
  line-height: 40px;
  background-image: url(../assets/images/favicon.png);
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: left center;
  padding-left: 20px;
}

@media screen and (max-width: 800px) {
  #serial {
    top: 5px;
  }

  ul#quickMbLink {
    display: flex;
    position: absolute;
    right: 0;
    top: 17px;
    vertical-align: middle;
  }

  ul#quickMbLink a {
    color: rgb(255, 255, 255);
  }

  #quickMbLink li {
    padding-right: 7px;
    opacity: 0.7;
    text-decoration: none;
  }
}
</style>
